"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _httpCore = require("@webex/http-core");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /*!
 * Copyright (c) 2015-2024 Cisco Systems, Inc. See LICENSE file.
 */
/**
 * This interceptor replaces the host in the request uri with the host from the hostmap
 * It will attempt to do this for every request, but not all URIs will be in the hostmap
 * URIs with hosts that are not in the hostmap will be left unchanged
 */
var HostMapInterceptor = exports.default = /*#__PURE__*/function (_Interceptor) {
  (0, _inherits2.default)(HostMapInterceptor, _Interceptor);
  var _super = _createSuper(HostMapInterceptor);
  function HostMapInterceptor() {
    (0, _classCallCheck2.default)(this, HostMapInterceptor);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(HostMapInterceptor, [{
    key: "onRequest",
    value:
    /**
     * @see Interceptor#onRequest
     * @param {Object} options
     * @returns {Object}
     */
    function onRequest(options) {
      if (options.uri) {
        try {
          options.uri = this.webex.internal.services.replaceHostFromHostmap(options.uri);
        } catch (error) {
          /* empty */
        }
      }
      return options;
    }
  }], [{
    key: "create",
    value:
    /**
     * @returns {HostMapInterceptor}
     */
    function create() {
      return new HostMapInterceptor({
        webex: this
      });
    }
  }]);
  return HostMapInterceptor;
}(_httpCore.Interceptor);
//# sourceMappingURL=hostmap.js.map
